var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classes},[_c('input',{attrs:{"type":_vm.type,"disabled":_vm.proxyDisabled},on:{"input":_vm.emitInput}}),_c('span',{class:_vm.$style.checkmark}),_c('span',{class:_vm.$style.text},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }